import { createAction } from 'typesafe-actions';

export const setLastCartId = createAction(
  '@order-cart/SET_LAST_CARD_ID'
)<string>();
